<template>
  <view class="packet {{template}}" wx:style="{{bgStyle}}">
    <view class="left {{numberDigit}}">
      <block wx:if="{{couponInfo}}">
        <text class="integer">{{valueObj.integer}}
        </text><text wx:if="{{valueObj.point}}" class="point">{{valueObj.point}}
        </text><text class="decimal">{{valueObj.decimal}}</text>
        <view class="desc">
          <view class="tip"> {{ couponTip }}  </view>
          <text class="unit">{{ couponInfo.max_benefit_capacity.unit }}</text>
        </view>
      </block>
    </view>
    <view class="right">
      <view class="title">{{ title }}</view>
      <view class="subtitle" wx:if="{{subtitle}}">{{subtitle}}</view>
    </view>
    <button class="btn" bindtap="click">{{ btnText }}</button>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { utils, trackEvent } from '@didi/webx-js'
import { formatValue } from '../../lib/utils'
import { pageStyle } from '../../lib/store'

const typeMap = {
  1: '最高',
  3: '最高',
  100: '低至',
}

createComponent({
  properties: {
    config: Object,
    couponInfo: Object,
    template: String,
    btnText: String,
  },
  computed: {
    valueObj() {
      return this.couponInfo ? formatValue(this.couponInfo.max_benefit_capacity.value) : {}
    },
    couponTip() {
      return typeMap[this.couponInfo.type]
    },
    title() {
      return this.config?._closeTitle || pageStyle[this.template].couponDefaultName
    },
    subtitle() {
      return this.config?.subTitle || pageStyle[this.template].couponSubTitle
    },
    numberDigit() {
      if (String(this.valueObj.integer).length + String(this.valueObj.decimal).length >= 3)
        return 'digit-3'
      else
        return ''
    },
    bgStyle() {
      return { backgroundImage: `url(${utils.webpUrl(pageStyle[this.template].couponBg)})` }
    },
  },
  ready() {
    trackEvent('userteam_ddlm_home_couponlist_claimnowbtn_sw', '滴滴联盟_领券页面_券包_立即领取按钮-展现')
  },
  methods: {
    click(e) {
      this.triggerEvent('click', e.detail)
    },
  },
})
</script>

<style lang="stylus" scoped>
  .packet
    box-sizing: border-box;
    width 750rpx
    height 370rpx
    background-size: 100% 100%
    background-image: url('https://ut-static.udache.com/webx/ut/ol88ndPIJYriloOhI8WJL.png')
    background-repeat: no-repeat
    margin-left auto
    margin-right auto
    overflow hidden
    position relative
    display flex
    padding 56rpx 52rpx 172rpx
    &.cz
      .left
        .tip
          width: 60rpx;
          height: 28rpx;
          line-height: 28rpx;
          background: #E33C2B;
      .right
        .title
          // width: 332rpx;
          height: 56rpx;
          font-family: PingFangSC-Semibold;
          font-size: 40rpx;
          color: #B24437;
          letter-spacing: 1.46rpx;
          font-weight: 600;
        .subtitle
          // width: 332rpx;
          height: 25rpx;
          opacity: 0.48;
          font-family: PingFangSC-Medium;
          font-size: 18rpx;
          color: #B24437;
          font-weight: 500;
    .left
      flex 1
      position relative
      font-size: 100rpx;
      font-family: DIN-Bold, DIN-Bold-self;
      color: #E33C2B;
      text-shadow: 1px 1px 0px #FFF;
      line-height 1
      display: flex;
      align-items: center;
      justify-content: center;
      top -12rpx
      &.digit-3
        font-size: 100rpx;
        letter-spacing -2rpx
      .point
        margin-left -4rpx
        margin-right -10rpx
      .desc
        display flex
        flex-direction column
      .unit
        font-size: 36rpx;
        font-family: PingFang SC;
        font-weight: bold;
        color: #E33C2B;
        text-shadow: 1px 1px 0 #FFF;
        position relative
        right: -8rpx
        bottom -24rpx
      .tip
        position absolute
        right: 36rpx;
        top: 2rpx;
        letter-spacing normal
        text-shadow: none
        width: 56rpx;
        height: 25rpx;
        background: #F3B651;
        border-radius: 13rpx 13rpx 13rpx 0;
        box-shadow: 1px 1px 0 0 rgba(255, 255, 255, 0.7);
        font-size: 18rpx;
        font-family: PingFang SC;
        font-weight: 300;
        color: #FFF;
        text-align center
        line-height 28rpx
    .right
      width 400rpx
      box-sizing border-box
      flex-shrink 0
      padding 0 0 36rpx 24rpx
      padding-bottom: 36rpx;
      align-self: center;
      .title
        font-size: 43rpx;
        font-family: PingFang SC;
        font-weight: 800;
        color: #B14536;
        text-shadow: 1px 1px 0px #FFFFFF;
    .btn, .limit
      position absolute
      left 50%
      transform translate(-50%)
    .btn
      background-image: linear-gradient(180deg, #FFFDE5 0%, #FFE490 100%);
      box-shadow: 0px 10rpx 19rpx 0px rgba(131,5,5,0.48);
      border-radius: 69rpx;
      width 486rpx
      height 118rpx
      line-height 118rpx
      bottom 41rpx
      font-size: 56rpx;
      font-family: PingFang SC;
      text-shadow: 0 2rpx 0 rgba(255,255,255,0.85);
      font-weight: bold;
      color: #E33D37;
      text-align center
      margin-bottom 0
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {
    "coupon-price": "../common/coupon-price.mpx"
  }
}
</script>
